import { __ } from '@wordpress/i18n';

const yearTypes = new Map();

yearTypes.set('compare', __('Compare Two Years', 'hst'));
yearTypes.set('range', __('Custom Range', 'hst'));
yearTypes.set('single', __('Single Year', 'hst'));

export default yearTypes;
